import React, { PropTypes, Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl'
import AnchorLink from '../components/AnchorLink'
import Feature from '../components/Feature'
import { messages as links } from '../app/App'
import './FeaturesSection.scss'

const messages = defineMessages({
  header: {
    id: 'features.header',
    defaultMessage: 'Proč začít se Stadyum CRM?',
  },
  salesHeader: {
    id: 'features.sales.header',
    defaultMessage: 'Zvýšíte prodeje',
  },
  salesText: {
    id: 'features.sales.text',
    defaultMessage: 'Zabudovaný emailing komunikuje s diváky. Díky tomu můžete odstraňovat nedostatky, kvůli kterým diváci nechodí.',
  },
  timeHeader: {
    id: 'features.time.header',
    defaultMessage: 'Ušetříte čas',
  },
  timeText: {
    id: 'features.time.text',
    defaultMessage: 'S naším systémem stihnete více práce za kratší dobu. Rádi usnadníme i individuální potřeby.',
  },
  resultsHeader: {
    id: 'features.results.header',
    defaultMessage: 'Výsledky vidíte ihned',
  },
  resultsText: {
    id: 'features.results.text',
    defaultMessage: 'Od teď se můžete rozhodovat na základě dat, ne jen podle intuice.',
  },
  roofHeader: {
    id: 'features.roof.header',
    defaultMessage: 'Vše pod jednou střechou',
  },
  roofText: {
    id: 'features.roof.text',
    defaultMessage: 'Emailing, ticketing, permanentky i přehledy zápasů máte na jednom místě.',
  },
  accessibleHeader: {
    id: 'features.accessible.header',
    defaultMessage: 'Jsme dostupní',
  },
  accessibleText: {
    id: 'features.accessible.text',
    defaultMessage: 'Pracujeme velmi efektivně, takže si Stadyum CRM může dovolit i klub s menším rozpočtem.',
  },
  helpHeader: {
    id: 'features.help.header',
    defaultMessage: 'Budeme vám pomáhat',
  },
  helpText: {
    id: 'features.help.text',
    defaultMessage: 'Ukážeme vám spoustu nových možností, které lze využít díky internetu. Na marketing od teď nejste sami.',
  },
})

const FeaturesSection = ({ intl }) => (
  <section className="features-section">
    <a name={intl.formatMessage(links.linkFeaturesUrl)} id={intl.formatMessage(links.linkFeaturesUrl)}></a>
    <h2>{intl.formatMessage(messages.header)}</h2>
    <Grid>
      <Row>
        <Col sm={6} md={4}>
          <Feature icon="diamond.svg" header={intl.formatMessage(messages.salesHeader)}>
            <p>
              <FormattedMessage {...messages.salesText} />
            </p>
          </Feature>
        </Col>
        <Col sm={6} md={4}>
          <Feature icon="clock.svg" header={intl.formatMessage(messages.timeHeader)}>
            <p>
              <FormattedMessage {...messages.timeText} />
            </p>
          </Feature>
        </Col>
        <Col sm={6} md={4}>
          <Feature icon="graph.svg" header={intl.formatMessage(messages.resultsHeader)}>
            <p>
              <FormattedMessage {...messages.resultsText} />
            </p>
          </Feature>
        </Col>
        <Col sm={6} md={4}>
          <Feature icon="umbrella.svg" header={intl.formatMessage(messages.roofHeader)}>
            <p>
              <FormattedMessage {...messages.roofText} />
            </p>
          </Feature>
        </Col>
        <Col sm={6} md={4}>
          <Feature icon="money.svg" header={intl.formatMessage(messages.accessibleHeader)}>
            <p>
              <FormattedMessage {...messages.accessibleText} />
            </p>
          </Feature>
        </Col>
        <Col sm={6} md={4}>
          <Feature icon="man.svg" header={intl.formatMessage(messages.helpHeader)}>
            <p>
              <FormattedMessage {...messages.helpText} />
            </p>
          </Feature>
        </Col>
      </Row>
    </Grid>
    <div className="callout">
      <AnchorLink to={`/#${intl.formatMessage(links.linkContactUrl)}`} className="call-to-action">
        {intl.formatMessage(links.linkInquiryText)}
      </AnchorLink>
    </div>
  </section>
)

FeaturesSection.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(FeaturesSection)



// WEBPACK FOOTER //
// ./src/browser/FeaturesSection/FeaturesSection.js